/*
 * @作者: kerwin
 * @公众号: 大前端私房菜
 */
import Home from '../views/home/Home.vue'
import Center from '../views/center/Center.vue'
import UserList from '../views/user-manage/UserList.vue'
import Userlog from '../views/user-manage/Userlog.vue'
import NewsAdd from '../views/news-manage/NewsAdd.vue'
import NewsList from '../views/news-manage/NewsList.vue'
import ProductAdd from '../views/product-manage/ProductAdd.vue'
import ProductList from '../views/product-manage/ProductList.vue'
import NotFound from '../views/notfound/NotFound.vue'
import UserVip from '../views/user-vip/OpenVip.vue'
import Addstyle from '../views/stylemanage/addstyle.vue'//添加风格
import Discover from '../views/stylemanage/discover.vue'//发现页管理

import BrandApply from '../views/brandManage/brandapply.vue'//贴牌申请

import ModesSet from '../views/modeManage/modes-set.vue'//模型设置
import LlmModesSet from '../views/modeManage/txt_modes-set.vue'//大语言模型设置
import PublicMessages from '../views/message-manage/PublicMessages.vue'//公共消息管理





const routes = [
    {//官网
        path: "/",
        redirect: "/official"
    },
    {//后台
        path: "/index",
        component: Home
    },
    {
        path: "/center",// 对应菜单的「数据统计」
        component: Center
    },
    {
        path: "/addstyle",//添加风格
        component: Addstyle
    },
    {
        path: "/discover",//发现页管理
        component: Discover
    },
    {
        path: "/brandapply",//贴牌申请
        component: BrandApply
    },
    {
        path: "/modesset",//模型设置
        component: ModesSet
    },
    {
        path: "/llm-models",//大语言模型设置
        component: LlmModesSet
    },
    {
        path: "/public-messages",
        component: PublicMessages,
        requireAdmin: true
    },
    {//vip管理开通
        path: "/user-vip/OpenVip",
        component: UserVip
    },
    {
        path: "/user-manage/userlist",
        component: UserList,
        requireAdmin: true
    },
    {
        path: "/user-manage/Userlog",
        component: Userlog,
        requireAdmin: true
    },
    {
        path: "/news-manage/addnews",
        component: NewsAdd
    },
    {
        path: "/news-manage/newslist",
        component: NewsList
    },
    {
        path: "/product-manage/addproduct",
        component: ProductAdd
    },
    {
        path: "/product-manage/productlist",
        component: ProductList
    },

    {
        path: "/:pathMatch(.*)*",
        name: "Notfound",
        component: NotFound
    }
]

export default routes
